export default __webpack_public_path__ + "static/media/survey-approved.14b5ff96.svg";